import api, { ApiResponse } from "../../api";
import { CloseDoorRequest, CloseDoorResponse, DispatchManifestRequest, DispatchManifestResponse, GetDispatchBoardQueueLoadDetailsRequest, GetDispatchBoardQueueLoadDetailsResponse, GetDispatchBoardQueueLoadRequest, GetDispatchBoardQueueLoadResponse, GetDispatchBoardQueueRequest, GetDispatchBoardQueueResponse, GetDoorsRequest, GetDoorsResponse, SetupDoorRequest, SetupDoorResponse } from "./models";

class CityDeliveryDiaptchBoardService {
  private source: any;
  private static instance: CityDeliveryDiaptchBoardService;

  private constructor() { }

  static getInstance(): CityDeliveryDiaptchBoardService {
    if (!CityDeliveryDiaptchBoardService.instance) {
      CityDeliveryDiaptchBoardService.instance = new CityDeliveryDiaptchBoardService();
    }
    return CityDeliveryDiaptchBoardService.instance;
  }

  public getDispatchBoardQueue = async (
    requestData: GetDispatchBoardQueueRequest
  ): Promise<ApiResponse<GetDispatchBoardQueueResponse>> => {
    return await api.get(
      "/disaptch-board/queue",
      { params: requestData }
    );
  };

  public getDispatchBoardQueueLoad = async (
    requestData: GetDispatchBoardQueueLoadRequest
  ): Promise<ApiResponse<GetDispatchBoardQueueLoadResponse>> => {
    return await api.get(
      "/disaptch-board/load",
      { params: requestData }
    );
  };

  public getDispatchBoardQueueLoadDetails = async (
    requestData: GetDispatchBoardQueueLoadDetailsRequest
  ): Promise<ApiResponse<GetDispatchBoardQueueLoadDetailsResponse>> => {
    return await api.get(
      "/disaptch-board/load/details",
      { params: requestData }
    );
  };

  public getDoors = async (
    requestData: GetDoorsRequest
  ): Promise<ApiResponse<GetDoorsResponse>> => {
    return await api.get(
      "/disaptch-board/doors",
      { params: requestData }
    );
  };

  public setupDoor = async (
    requestData: SetupDoorRequest
  ): Promise<ApiResponse<SetupDoorResponse>> => {
    return await api.post("/disaptch-board/setup-door", requestData);
  };

  public closeDoor = async (
    requestData: CloseDoorRequest
  ): Promise<ApiResponse<CloseDoorResponse>> => {
    return await api.post("/disaptch-board/close-door", requestData);
  };

  public dispatchManifest = async (
    requestData: DispatchManifestRequest
  ): Promise<ApiResponse<DispatchManifestResponse>> => {
    return await api.post("/disaptch-board/dispatch-manifest", requestData);
  };
  
}

export default CityDeliveryDiaptchBoardService;